import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import CircularProgress from "@material-ui/core/CircularProgress";
import Alert from "@material-ui/lab/Alert";
import Snackbar from "@material-ui/core/Snackbar";
import Typography from "@material-ui/core/Typography";
import { COLOR_NAVY } from "../common/constants";
import { authHttpFactory, HTTP } from "../../apiConfig";
import EmbeddedSignature from "./embeddedSignature";
import CodeTimer from "../common/CodeTimer";
import OtpSignature from "./otpSignature";

const propTypes = {
  match: PropTypes.object.isRequired,
};

const StyledFlex = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
`;

class Signing extends Component {
  constructor(props) {
    super(props);

    this.jwt = new URLSearchParams(window.location.search).get("jwt");

    this.state = {
      accessBlocked: false,
      signingType: null,
      loading: true,
      showAlert: false,
      alertMessage: "",
      alertSeverity: null,
      alertAutoHide: true,
      verificationCode: null,
    };
  }

  componentDidMount() {
    if (this.jwt) {
      this.getVerificationCode(this.jwt);
    } else {
      this.http = authHttpFactory(this.signingId);
      this.getSigningType(this.signingId);
    }
  }

  handleCloseToast(event, reason) {
    if (reason === "clickaway") {
      return;
    }

    this.setState({
      showAlert: false,
    });
  }

  getVerificationCode(jwt) {
    HTTP.get("/forms/verificationCode", { params: { jwt } }).then(
      (response) => {
        const verificationCode = {
          value: response.data.verificationCode,
          expirationDate: new Date(response.data.expirationDate),
        };
        this.setState({ verificationCode });

        this.http = authHttpFactory(this.signingId, verificationCode);
        this.getSigningType(this.signingId);
      }
    );
  }

  getSigningType(signingId) {
    this.http.get(`/signing/${signingId}/type`).then(
      (response) => {
        this.setState({
          loading: false,
          signingType: response.data.signingType,
        });
      },
      (err) => {
        this.setState({ loading: false });
        if (err && err.response && err.response.status === 410) {
          this.showError("The access link has expired.");
        } else if (err && err.response && err.response.status === 423) {
          this.showError("The document is no longer available.");
        } else if (err.code !== "ERR_CANCELED") {
          this.showError("An Unexpected Error Occurred");
        }
      }
    );
  }

  get signingId() {
    return this.props.match.params.signingId;
  }

  blockPage() {
    this.setState({ accessBlocked: true });
  }

  showAlert(message, severity, autoHide) {
    this.setState({
      showAlert: true,
      alertMessage: message,
      alertSeverity: severity,
      alertAutoHide: autoHide,
    });
  }

  hideAlert() {
    this.setState({ showAlert: false });
  }

  showError(message) {
    this.setState({
      showAlert: true,
      alertMessage: message,
      alertSeverity: "error",
      accessBlocked: true,
    });
  }

  render() {
    return (
      <StyledFlex>
        {this.state.verificationCode && this.state.signingType && (
          <CodeTimer verificationCode={this.state.verificationCode} />
        )}

        <StyledFlex
          style={
            this.state.loading || this.state.accessBlocked
              ? { display: "none" }
              : {}
          }
        >
          {this.state.signingType === "OTP" && (
            <OtpSignature
              signingId={this.signingId}
              setLoading={(loading) => this.setState({ loading })}
              blockPage={() => this.blockPage()}
              showAlert={(message, severity, autoHide = true) =>
                this.showAlert(message, severity, autoHide)
              }
            />
          )}
          {this.state.signingType === "Embedded" && (
            <EmbeddedSignature
              signingId={this.signingId}
              setLoading={(loading) => this.setState({ loading })}
              blockPage={() => this.blockPage()}
              showAlert={(message, severity, autoHide = true) =>
                this.showAlert(message, severity, autoHide)
              }
              hideAlert={() => this.hideAlert()}
            />
          )}
        </StyledFlex>

        {this.state.loading && (
          <CircularProgress
            style={{ color: COLOR_NAVY }}
            size={100}
            thickness={1}
          />
        )}

        <Snackbar
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          open={this.state.showAlert}
          autoHideDuration={this.state.alertAutoHide ? 5000 : null}
          onClose={(event, reason) => this.handleCloseToast(event, reason)}
        >
          <Alert
            onClose={(event, reason) => this.handleCloseToast(event, reason)}
            severity={this.state.alertSeverity}
          >
            <Typography variant="h6" gutterBottom>
              {this.state.alertMessage}
            </Typography>
          </Alert>
        </Snackbar>
      </StyledFlex>
    );
  }
}

Signing.propTypes = propTypes;
export default Signing;
